import { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "../../axios";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import { IP } from "../../internalServer";
import ComponentType from "../../Enum/ComponentTypeEnum";
import { iconData } from "../../iconData";
import PdfViewer from "./PdfViewer";
import { shortenParagraph } from "../../Utils/helper";
import { toast } from "react-toastify";

const QuestionPaperMapper = ({
  onClose,
  onSaveSubmit,
  selectedBox,
  componentType,
}) => {
  const [totalQuestions, setTotalQuestions] = useState("");
  const [totalMarks, setTotalMarks] = useState("");
  const [totalMCQs, setTotalMCQs] = useState("");
  const [table, setTable] = useState(false);
  const [questionType, setQuestionType] = useState([]);
  const [commonAttachments, setCommonAttachments] = useState([]);
  const [loader, setLoader] = useState(false);
  const [fLimit, setFLimit] = useState(false);
  const [zoomedAttachment, setZoomedAttachment] = useState(null);
  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState("");

  const validateFileType = (file) => {
    // ✅ Assessment & Question Bank → ONLY PDF + IMAGES
    if (
      componentType === ComponentType.ASSESSMENT ||
      componentType === ComponentType.QUESTION_BANK
    ) {
      const allowed = /\.(pdf|jpg|jpeg|png)$/i;
      return allowed.test(file.name);
    }

    // ✅ Other components → broader support
    const allowedExtensions =
      /\.(pdf|doc|docx|ppt|pptx|xls|xlsx|jpg|jpeg|png)$/i;

    return allowedExtensions.test(file.name);
  };

  const handleCommonAttachment = async (files) => {
    if (!files || files.length === 0) return;

    const file = files[0];

    // ❌ Block audio/video
    if (file.type.startsWith("video/") || file.type.startsWith("audio/")) {
      toast.error("Audio / Video files are not allowed");
      return;
    }

    // ❌ Strict validation for Assessment / Question Bank
    if (!validateFileType(file)) {
      toast.error(
        componentType === ComponentType.ASSESSMENT ||
          componentType === ComponentType.QUESTION_BANK
          ? "Only PDF or Image files are allowed "
          : "Invalid file type selected",
      );

      document.getElementById("commonAttachment").value = "";
      return;
    }

    // ❌ Size limit
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.warning("Maximum file size allowed is 10 MB");
      setFLimit(true);
      return;
    }

    try {
      setLoader(true);

      const teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
      const formData = new FormData();
      formData.append("name", file.name);
      formData.append("uploadQuestionAttachment", file);

      const res = await axios.post(
        `/api/v1/question/uploadAttachment/teacherId/${teacher_id}`,
        formData,
      );

      const attachmentObj = {
        url: res.data.data,
        name: file.name,
      };

      setCommonAttachments([attachmentObj]);

      setQuestions((prev) =>
        prev.map((q) => ({
          ...q,
          attachments: [attachmentObj],
        })),
      );

      toast.success("Attachment uploaded successfully ✅");

      setLoader(false);
      setFLimit(false);
      document.getElementById("commonAttachment").value = "";
    } catch (err) {
      console.error(err);
      toast.error("Failed to upload attachment");
      setLoader(false);
    }
  };

  console.log(commonAttachments, "commonAttachments");

  const school_id = JSON.parse(localStorage.getItem("schoolId"));

  const checkQuestionTypes = async () => {
    try {
      const res = await axios.get(
        `/api/v1/questionType/get/school/${school_id}`,
      );

      console.log(res.data.data, "res");

      if (res.data.data.length > 0) {
        setQuestionType(res.data.data);
      }
    } catch (error) {
      console.log(error, "error while fetching quwstion type");
    }
  };

  console.log(questionType, "questionType");

  useEffect(() => {
    checkQuestionTypes();
  }, [school_id]);

  // MAIN QUESTIONS STATE
  const [questions, setQuestions] = useState([]);

  // Change question type
  const handleQuestionTypeChange = (index, questionTypeId) => {
    const selected = questionType.find((qt) => qt.id === questionTypeId);

    setQuestions((prev) =>
      prev.map((q, i) =>
        i === index
          ? {
              ...q,
              questionTypeId,
              type: selected?.type || "",
            }
          : q,
      ),
    );
  };

  // Delete question
  const handleDeleteQuestion = (index) => {
    setQuestions((prev) => prev.filter((_, i) => i !== index));
    setTotalQuestions((prev) => prev - 1);
  };

  const tableScrollRef = useRef(null);

  useEffect(() => {
    if (!tableScrollRef.current) return;

    tableScrollRef.current.scrollTo({
      top: tableScrollRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [questions.length]);

  const handleSaveSubmit = () => {
    const payload = questions.map((q, index) => ({
      index,
      title: q.title,
      correct_score: totalMarks,
      type_id: q.questionTypeId,
      type: q.type,
      mcqOptionsCount: q.type === "multiple choice" ? totalMCQs : 0,
      correct_answer: q.correctAnswer ?? null,
      teacher_note: q.teacherNote ?? null,
      attachments: q.attachments ?? [],
    }));

    console.log(payload, "payload");
    onSaveSubmit(payload);
  };

  console.log(questions, "questions");

  const isAdaptiveMode =
    selectedBox === "adaptive" ||
    selectedBox === "auto-evaluate" ||
    selectedBox?.adaptive ||
    selectedBox?.isAdaptive ||
    selectedBox?.autoEvaluate;

  const isSubmitDisabled =
    !table ||
    questions.some((q) => q.type === "multiple choice" && !q.correctAnswer);

  const cellSx = {
    fontWeight: 600,
    fontSize: "0.875rem",
    borderBottom: "2px solid",
    borderColor: "divider",
    py: 1.5,
  };

  const MandatoryLabel = ({ label }) => (
    <>
      {label} <span style={{ color: "#d32f2f" }}>*</span>
    </>
  );

  const handleClickforpdf = (attachment) => {
    setTimeout(() => {
      setResponseAttach(attachment);
      setMideaviewer(true);
    }, 100);
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "96%",
          maxWidth: 1700,
          height: "90vh",
          bgcolor: "#f5f7fb",
          zIndex: 9999,
          overflow: "auto",
          borderRadius: 2,
          boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          p: 2,
        }}
      >
        {/* HEADER */}
        <Card sx={{ mb: 2 }}>
          <CardContent
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 2,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              Question Paper Mapper
            </Typography>

            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </CardContent>
        </Card>

        {/* BODY */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "0.7fr 2.4fr" },
            gap: 3,
          }}
        >
          {/* LEFT PANEL */}
          <Card>
            <CardContent>
              {/* 🔴 Mandatory Info */}
              <Typography
                variant="caption"
                sx={{
                  color: "#d32f2f",
                  mb: 1,
                  display: "block",
                  text: "center",
                }}
              >
                👉🏿 All fields marked with * are mandatory
              </Typography>

              {/* 📎 COMMON ATTACHMENT */}
              <Box
                sx={{
                  border: "1px dashed #cbd5e1",
                  borderRadius: 2,
                  p: 2,
                  textAlign: "center",
                  mb: 2,
                }}
              >
                <input
                  type="file"
                  id="commonAttachment"
                  style={{ display: "none" }}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  onChange={(e) => handleCommonAttachment(e.target.files)}
                />

                <label htmlFor="commonAttachment" style={{ cursor: "pointer" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    <AttachFileIcon sx={{ color: "#64748b", fontSize: 20 }} />

                    <Typography fontWeight={600}>
                      <MandatoryLabel label="Upload Question Attachment" />
                    </Typography>
                  </Box>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    (File will be added to All Questions)
                  </Typography>
                </label>

                {loader && <Typography>Uploading...</Typography>}

                {fLimit && (
                  <Typography color="error" fontSize={12}>
                    Max file size 10 MB
                  </Typography>
                )}
              </Box>

              {/* 🔥 ATTACHMENT PREVIEW */}
              {commonAttachments.length > 0 && (
                <Box sx={{ my: 2 }}>
                  {commonAttachments.map((att, idx) => {
                    const ext = att.url.split(".").pop().toLowerCase();
                    const isImage = ["jpg", "jpeg", "png"].includes(ext);
                    const isPDFDoc = ["pdf", "doc", "docx"].includes(ext);
                    const fileIcon =
                      iconData?.find((i) => i.extension === ext)?.icon || "";

                    const fullUrl = att.url.startsWith("http")
                      ? att.url
                      : `${IP}${att.url}`;

                    return (
                      <Box
                        key={idx}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          border: "1px solid #ddd",
                          p: 1,
                          borderRadius: 1,
                        }}
                      >
                        {isImage ? (
                          <img
                            src={fullUrl}
                            alt="attachment"
                            onClick={() => setZoomedAttachment(fullUrl)}
                            style={{
                              width: "100%",
                              height: 60,
                              objectFit: "cover",
                              borderRadius: 4,
                              cursor: "pointer",
                            }}
                          />
                        ) : isPDFDoc ? (
                          <div
                            className="d-flex align-items-center"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClickforpdf(att.url)}
                          >
                            <img
                              src={fileIcon}
                              alt="attachment icon"
                              className="mr-2"
                            />
                            <Typography fontSize={12}>
                              {shortenParagraph(att.name, 20)}
                            </Typography>
                          </div>
                        ) : (
                          <Typography fontSize={12}>{att.name}</Typography>
                        )}

                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => {
                            setCommonAttachments([]);
                            setQuestions((prev) =>
                              prev.map((q) => ({ ...q, attachments: [] })),
                            );
                            document.getElementById("commonAttachment").value =
                              "";
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    );
                  })}
                </Box>
              )}

              {/* 🔢 TOTAL QUESTIONS */}
              <TextField
                fullWidth
                type="number"
                label={<MandatoryLabel label="Total Questions" />}
                value={totalQuestions}
                onChange={(e) =>
                  setTotalQuestions(
                    e.target.value === "" ? "" : Number(e.target.value),
                  )
                }
                sx={{ mb: 2 }}
                disabled={table}
              />

              {/* 🧮 MARKS */}
              <TextField
                fullWidth
                type="number"
                label={<MandatoryLabel label="Marks Per Question" />}
                value={totalMarks}
                onChange={(e) =>
                  setTotalMarks(
                    e.target.value === "" ? "" : Number(e.target.value),
                  )
                }
                sx={{ mb: 2 }}
                disabled={table}
              />

              {/* 🔘 MCQ COUNT */}
              <TextField
                fullWidth
                type="number"
                label={<MandatoryLabel label="MCQ Options Count (2–5)" />}
                value={totalMCQs}
                inputProps={{ min: 2, max: 5 }}
                onChange={(e) => {
                  const raw = e.target.value;

                  if (raw === "") {
                    setTotalMCQs("");
                    return;
                  }

                  let val = Number(raw);

                  if (val < 2) val = 2;
                  if (val > 5) val = 5;

                  setTotalMCQs(val);
                }}
                sx={{ mb: 3 }}
                disabled={table}
              />

              {/* 🚀 SUBMIT */}
              <Button
                fullWidth
                variant="contained"
                disabled={
                  !totalQuestions ||
                  !totalMarks ||
                  !totalMCQs ||
                  table ||
                  commonAttachments.length === 0
                }
                onClick={() => {
                  const mcq = questionType?.find(
                    (qt) => qt.type === "multiple choice",
                  );

                  setQuestions(
                    Array.from({ length: totalQuestions }).map((_, i) => ({
                      id: i + 1,
                      questionTypeId: mcq?.id || "",
                      title: `Refer Ques No ${i + 1} in Attachment`,
                      type: mcq?.type || "",
                      correctAnswer: null,
                      teacherNote: "",
                      attachments: commonAttachments,
                    })),
                  );
                  setTable(true);
                }}
              >
                Generate Answer Sheet
              </Button>
            </CardContent>
          </Card>

          {/* RIGHT PANEL */}
          <Card>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography fontWeight={600}>
                  Answer Sheet (Provide your Input to Proceed)
                </Typography>

                {isAdaptiveMode && table && (
                  <Typography fontSize={11} color="teal" mt={0.5}>
                    Question type is locked to MCQ in Adaptive / Auto-Evaluate
                    mode
                  </Typography>
                )}

                <Box sx={{ display: "flex", gap: 1 }}>
                  {table && (
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => {
                        setTable(false);
                        setQuestions([]);
                        setTotalQuestions("");
                        setTotalMarks("");
                        setTotalMCQs("");
                      }}
                    >
                      Cancel
                    </Button>
                  )}

                  <Button
                    variant="contained"
                    color="success"
                    disabled={isSubmitDisabled}
                    onClick={handleSaveSubmit}
                  >
                    Proceed
                  </Button>
                </Box>
              </Box>

              {/* TABLE / EMPTY STATE */}
              {table ? (
                <>
                  <Box
                    ref={tableScrollRef}
                    sx={{
                      maxHeight: "55vh",
                      overflowY: "auto",
                      overflowX: "visible",
                      border: "1px solid #e5e7eb",
                      borderRadius: 1,
                      zIndex: 1,
                    }}
                    className="orange-scrollBar"
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow
                          sx={{
                            backgroundColor: (theme) => theme.palette.grey[100],
                          }}
                        >
                          <TableCell align="center" sx={cellSx}>
                            Question Title{" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </TableCell>

                          <TableCell align="center" sx={cellSx}>
                            Question Type{" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </TableCell>

                          <TableCell align="center" sx={cellSx}>
                            Select Correct Answer{" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </TableCell>

                          <TableCell align="center" sx={cellSx}>
                            Reason for Correct Answer{" "}
                            <span style={{ color: "#ed6c02", fontWeight: 500 }}>
                              (Optional)
                            </span>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {questions.map((q, i) => (
                          <TableRow key={i}>
                            <TableCell>
                              <TextField
                                size="small"
                                fullWidth
                                value={q.title || ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setQuestions((prev) =>
                                    prev.map((item, idx) =>
                                      idx === i
                                        ? { ...item, title: value }
                                        : item,
                                    ),
                                  );
                                }}
                                placeholder={`Refer Ques No ${
                                  i + 1
                                } in Attachment`}
                              />
                            </TableCell>

                            <TableCell>
                              <Select
                                size="small"
                                fullWidth
                                disabled={isAdaptiveMode}
                                value={q.questionTypeId}
                                onChange={(e) =>
                                  handleQuestionTypeChange(i, e.target.value)
                                }
                                MenuProps={{
                                  disablePortal: true, // ✅ MOST IMPORTANT
                                  PaperProps: {
                                    sx: {
                                      zIndex: 12000,
                                    },
                                  },
                                }}
                              >
                                {questionType?.map((qt) => (
                                  <MenuItem key={qt.id} value={qt.id}>
                                    {qt.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </TableCell>

                            <TableCell className="text-center">
                              {q.type === "multiple choice" ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: 1,
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  {Array.from({ length: totalMCQs }).map(
                                    (_, idx) => {
                                      const label = String.fromCharCode(
                                        65 + idx,
                                      );
                                      return (
                                        <Button
                                          key={label}
                                          size="small"
                                          variant={
                                            q.correctAnswer === label
                                              ? "contained"
                                              : "outlined"
                                          }
                                          onClick={() => {
                                            setQuestions((prev) =>
                                              prev.map((item, idx) =>
                                                idx === i
                                                  ? {
                                                      ...item,
                                                      correctAnswer: label,
                                                    }
                                                  : item,
                                              ),
                                            );
                                          }}
                                        >
                                          {label}
                                        </Button>
                                      );
                                    },
                                  )}
                                </Box>
                              ) : (
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  textAlign="center"
                                >
                                  N/A
                                </Typography>
                              )}
                            </TableCell>

                            <TableCell>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <TextField
                                  size="small"
                                  placeholder=" Reason for Correct Answer (Optional)"
                                  fullWidth
                                  value={q.teacherNote || ""}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setQuestions((prev) =>
                                      prev.map((item, idx) =>
                                        idx === i
                                          ? { ...item, teacherNote: value }
                                          : item,
                                      ),
                                    );
                                  }}
                                />

                                <IconButton
                                  color="error"
                                  onClick={() => handleDeleteQuestion(i)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>

                  {/* ADD MORE QUESTIONS */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => {
                        const mcq = questionType?.find(
                          (qt) => qt.type === "multiple choice",
                        );

                        setQuestions((prev) => [
                          ...prev,
                          {
                            id: prev.length + 1,
                            questionTypeId: mcq?.id || "",
                            type: mcq?.type || "",
                            title: `Refer Ques No ${
                              prev.length + 1
                            } in Attachment`,
                            teacherNote: "",
                            correctAnswer: null,
                            attachments: commonAttachments,
                          },
                        ]);

                        setTotalQuestions((prev) => prev + 1);
                      }}
                    >
                      + Add More Questions
                    </Button>
                  </Box>
                </>
              ) : (
                <Box
                  sx={{
                    minHeight: 260,
                    border: "1px dashed #d1d5db",
                    borderRadius: 2,
                    bgcolor: "#fafafa",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    p: 3,
                  }}
                >
                  <Typography fontWeight={600}>
                    No questions added yet
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ maxWidth: 360, mt: 1, mb: 2 }}
                  >
                    Please enter <b>Total Questions</b> on the left panel to
                    generate the answer sheet.
                  </Typography>

                  <Chip
                    label="Tip: Start by entering Total Questions"
                    color="warning"
                  />
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>

        {zoomedAttachment && (
          <div
            tabIndex={-1}
            onKeyDown={(e) => {
              if (e.key === "Escape") {
                setZoomedAttachment(null);
              }
            }}
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 100000,
            }}
          >
            {/* MODAL BOX */}
            <button
              onClick={() => setZoomedAttachment(null)}
              aria-label="Close"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                border: "none",
                background: "#111827",
                color: "#fff",
                fontSize: "22px",
                cursor: "pointer",
                zIndex: 10,
              }}
            >
              ×
            </button>
            <div
              style={{
                position: "relative",
                width: "80vw",
                maxWidth: "900px",
                height: "80vh",
                // background: "#fff",
                borderRadius: "10px",
                padding: "16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* CLOSE BUTTON */}

              {/* IMAGE */}
              <img
                src={zoomedAttachment}
                alt="Zoomed Attachment"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  borderRadius: "6px",
                }}
              />
            </div>
          </div>
        )}
      </Box>
      {mideaviewer && (
        <PdfViewer
          setMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
    </>
  );
};

export default QuestionPaperMapper;
